<template>
    <div class="modal2fa-popup">
        <confirmationDialog
        :dialogStatus="dialogStatus"
        :title="'Reset 2FA'"
        :eventName="'twoFaEvent'"
        @twoFaEvent="twoFaActions"
        :actions="!validateOldCode ? validateCodeActions : twoFaCodeActions"
        >
            <v-container class="pa-0">
                <div class="resetpage-content">
                    <div v-if="validateOldCode">
                        <div class="qrcode__container">
                            <div>
                                <p>You will need a 2FA method for security. Please download and install any authenticator app on your phone. If it is already installed, you can skip this screen!</p>
                                <p>1.Download and install an app (such as Google Authenticator) on your mobile.</p>
                                <p>2. Open the authenticator and scan the QR code.</p>
                            </div>
                        </div>
                        <div class="qr-code" v-html="htmlCode"></div>
                        <p>3. Enter the 6-digit verification code generated.</p>
                        <!-- <label>Factor authentication code</label> -->
                    </div>
                    <div class="form-element customized-textfield">
                        <label class="pl-1">Factor authentication code</label>
                        <v-text-field
                            placeholder="Enter 2-factor authentication code"
                            solo
                            flat
                            background-color="#F7F7F7"
                            color="#E34E25"
                            v-model="otpCode"
                            :append-icon="otpCode ? 'clear' : ''"
                            @click:append="otpCode = ''"
                            :error-messages="this.invalidOTP ? 'Invalid verification code' : ''"
                        >
                        </v-text-field>
                    </div>
                </div>
            </v-container>
        </confirmationDialog>
      
    </div>
</template>

<script>
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';
import confirmationDialog from '../../epsrc/components/common/confirmationDialog';
export default {
    name: 'ModalPopup2FA',
    data () {
        return {
            otpCode: '',
            invalidOTP: false,
            configureOTP: false,
            htmlCode: '',
            validateOldCode: false,
            hide:null,
            validateCodeActions: [
                {'text': 'CANCEL', 'action': 'cacelValidation', 'status': 'enabled'},
                {'text': 'Validate and Remove', 'action': 'validateCode', 'status': 'enabled'},
            ],
            twoFaCodeActions: [
                {'text': 'CANCEL', 'action': 'cacelValidation', 'status': 'enabled'},
                {'text': 'ENABLE TWO FACTOR AUTHENTICATION', 'action': 'enableTwoFa', 'status': 'enabled'},
            ]
        }
    },
    props: {
        dialogStatus: {
            type: Boolean,
            default: false
        }
    },
    components: {
        confirmationDialog
    },
    created() {
    },
    watch: {
        otpCode(){
            this.invalidOTP = false;
        }
    },
    methods: {
        twoFaActions(data) {
            var self = this;
            if (data.action == 'validateCode') {
                self.validateCode();
            } else if (data.action == 'enableTwoFa') {
                self.enableOTP();
            } else {
                self.$emit('close');
            }
        },
        getCSFRToken(name){
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        enableOTP(){
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            var secret_key = $('input[name="secret_key"]').val();
            var otp_type = $('input[name="otp_type"]').val();
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('verification_code', self.otpCode);
            formData.append('secret_key', secret_key);
            formData.append('otp_type', otp_type);
            if(!self.invalidOTP){
                showLoadIcon();
                this.$loading(true);
                Vue.http.post("/settings/mfa/enable/", formData)
                .then((data) => {
                    try{
                        // console.log(data);
                        self.htmlCode = '';
                        self.validateOldCode = false;
                        self.$emit('close', true);
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.invalidOTP = true;
                    console.log("OTP config failed with error:" + error)
                });
            }
        },

        getOTPConfig(){
            var self = this;
            self.validateOldCode = true;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get("/settings/mfa/configure/")
                .then((data) => {
                    try{
                        // console.log(data);
                        self.htmlCode = data.data;
                        // document.getElementById("configCode").innerHTML = data;
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    console.log("enable verification failed with error:" + error)
            });
        },

        reset2FA(){
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/settings/mfa/disable/", formData)
            .then((data) => {
                try{
                    // window.location = "/index.html#/";
                    // console.log(data);
                    self.getOTPConfig();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                // self.invalidOTP = true;
                console.log("API failed with this error:" + error)
            });
        },

        validateCode(){
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('verification_code', self.otpCode);
            if(!self.invalidOTP){
                showLoadIcon();
                this.$loading(true);
                Vue.http.post("/settings/verify/token/", formData)
                .then((data) => {
                    try{
                        self.otpCode = '';
                        self.reset2FA();
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.invalidOTP = true;
                    console.log("Verification failed with error:" + error)
                });
            }
        },
        showLoadIcon,
        hideLoadIcon
  }
}
</script>